import {FunctionComponent, useEffect, useState} from "react";
import userService from "../../services/userService";
import {
    Box,
    Card,
    Typography
} from "@mui/material";
import {UserList} from "../common/UserList";
import {IUserModel} from "../../types/UserModel";

export const UserReviewList: FunctionComponent = () => {
    const [users, setUsers] = useState<IUserModel[]>([]);

    async function getUsers() {
        const users = await userService.getUsersForReview();
        setUsers(users);
    }

    useEffect(() => {
        void getUsers();
    }, []);

    return (
        <Box>
            <Typography variant={'h1'} sx={{mb: 4}}>
                Review Users
            </Typography>

            <Card style={{marginBottom: 30}}>
                <UserList users={users} showName={false} showLoginTime={true} to={"user-review"}/>
            </Card>
        </Box>
    )
}